import { render, staticRenderFns } from "./AdminReviewForm.vue?vue&type=template&id=774bf842&scoped=true&"
import script from "./AdminReviewForm.vue?vue&type=script&lang=js&"
export * from "./AdminReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminReviewForm.vue?vue&type=style&index=0&id=774bf842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774bf842",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VRating,VRow,VTextarea})
